import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../views/movement-compare/Index.vue')
const StandardList = () => import('../views/movement-compare/StandardList.vue')
const StandardDetail = () => import('../views/movement-compare/StandardDetail.vue')
const RecordList = () => import('../views/movement-compare/RecordList.vue')
const RecordDetail = () => import('../views/movement-compare/RecordDetail.vue')

const indexRoute: RouteConfig = {
  path: '/movement-compare-index',
  name: 'movement_compare_index',
  component: Index,
  meta: {
    title: '动作姿态检测',
  },
}

const standardListRoute: RouteConfig = {
  path: '/movement-compare-standard-list',
  name: 'movement_compare_standard_list',
  component: StandardList,
  meta: {
    title: '动作姿态检测-标准动作库',
  },
}

const standardDetailRoute: RouteConfig = {
  path: '/movement-compare-standard-detail',
  name: 'movement_compare_standard_detail',
  component: StandardDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '标准运动详情页',
  },
}

const recordListRoute: RouteConfig = {
  path: '/movement-compare-record-list',
  name: 'movement_compare_record_list',
  component: RecordList,
  meta: {
    title: '动作姿态检测记录',
  },
}

const recordDetailRoute: RouteConfig = {
  path: '/movement-compare-record-detail',
  name: 'movement_compare_record_detail',
  component: RecordDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '动作姿态检测详情',
  },
}

export default [indexRoute, standardListRoute, standardDetailRoute, recordListRoute, recordDetailRoute]

export function navigateToMoveStandardDetailRoute(router: VueRouter, id: string) {
  router.push({ name: standardDetailRoute.name, params: { id: id } })
}
